<template lang="pug">       
  v-row(no-gutters)
    v-col(cols=12)
      form(@submit.prevent)
        v-row.mt-3(no-gutters)
          n-text-field-specific(
            v-model='memberSearch'
            :placeholder="$t('placeholder.search-member')"
            hide-details
          )
          v-btn.ml-2(
            type='submit'
            height='40'
            depressed
            dark
            color='var(--bg-secondary-color)'
            @click='seachMember()'
          )
            v-icon mdi-magnify
            | {{ $t('button.search') }}
  
      n-data-table-card-result(
        :headers='headers'
        :items='items'
        :meta='meta' 
        @nextpage='nextpage'
      ).mt-3 
        template(#item.rightActionEffectToCard='{item}')
          | {{ item.created_at | dateFormat}}  
</template>
<script> 
import { affiliate as apiAffiliate } from '@/apis'

export default { 
  data: () => ({
    memberSearch : null,
    items : [], 
    meta : {
      current_page:1
    },
    headers:[  
      { text: 'table.username', value: 'username'},
      { text: 'table.sum-total-amount', value: 'sum_total_amount', format:'currency' },
      { text: 'table.sum-lottery-amount', value: 'sum_lottery_amount', format:'currency' },
      { text: 'table.sum-casino-amount', value: 'sum_casino_amount' }, 
      { text: 'table.sum-football-amount', value: 'sum_football_amount' }, 
      { text: 'table.sum-slot-amount', value: 'sum_slot_amount' }, 
      { text: 'table.sum-powerball-amount', value: 'sum_powerball_amount' }, 
      { text: 'table.register-date', value: 'rightActionEffectToCard' }, 
    ],
  }), 
  async created () {
    await this.load() 
  },
  methods : {
    nextpage (value) {
      this.meta.current_page = value
      this.load()
    },

    async load (params = {}) {
      params = {
        page : this.meta.current_page,
        username : this.memberSearch
      } 

      const [err,data,,meta] = await apiAffiliate.getMember(params) 

        if(err) {
          this.$alert('',err,'warning')  
          return
        } 

        this.items = data
        this.meta = meta  
    },

    seachMember () {
      this.$ga.event('Button', 'SearchMember', 'AffiliatePage','' )
      this.load()
    }
  }
}
</script> 